'use client';

import {
  Box,
  Stack,
  Separator,
  AbsoluteCenter,
  type StackProps,
} from '@react/chakra';

import type { JSX } from 'react';

import { KofiButton } from '../Kofi';
import { MomoButton } from '../MomoButton';

export function DonationButton(props: StackProps): JSX.Element {
  return (
    <Stack alignItems='center' gap={5} {...props}>
      <KofiButton />
      <Box w='160px' position='relative' py={1}>
        <Separator w='100%' variant='dashed' />
        <AbsoluteCenter bgColor='gray.800' px={4}>
          Or
        </AbsoluteCenter>
      </Box>
      <MomoButton />
    </Stack>
  );
}
